import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { StaticImage } from '../../../../../image'

import ImgOldMan from './oldMan.png'
import { RxLpComHeroDescription } from './RxLpComHeroDescription'

export const RxLpComHero: FC = () => {
  const intl = useIntl()

  return (
    <div className="bg-light-primary-medium pt-4 tablet:h-72 tablet:flex-row tablet:justify-center tablet:bg-light-brand-high tablet:pt-0">
      <div className="container flex px-4">
        <RxLpComHeroDescription />
        <StaticImage
          alt={intl.formatMessage({ id: 'general.link.label.recipe' })}
          className="hidden h-72 w-auto object-contain tablet:block"
          src={ImgOldMan}
        />
      </div>
    </div>
  )
}
